import { useGlobal } from "../contexts/globalContext";
import { useParams, useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import { trackEvent } from "../lib/analytics";

function SearchBox() {
  const navigate = useNavigate();
  const { min, max } = useParams();
  const { keyword, setKeyword, sort, pageNumber } = useGlobal();

  function submitHandler(e, overrideMin, overrideMax) {
    e.preventDefault();

    let route = "/search";
    if (keyword.trim()) route += `/${keyword}`;
    if (sort) route += `/sort/${sort}`;
    if (overrideMin) route += `/min/${overrideMin}`;
    if (overrideMax) route += `/max/${overrideMax}`;
    if (pageNumber) route += `/page/${pageNumber}`;
    trackEvent("search_performed", {
      keyword: keyword.trim() || "all",
      sort: sort || "default",
    });
    navigate(route);
  }

  return (
    <form onSubmit={(e) => submitHandler(e, min, max)} className="w-full">
      <div className="relative w-full min-w-[220px]">
        <input
          type="text"
          name="q"
          onChange={(e) => setKeyword(e.target.value)}
          value={keyword}
          placeholder="Search"
          className="w-full rounded-full border border-slate-300 bg-white px-5 py-3 pr-16 text-base text-slate-800 outline-none transition focus:border-sky-300 focus:ring-2 focus:ring-sky-100"
        />
        <button
          type="submit"
          aria-label="Search"
          className="absolute right-1.5 top-1/2 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-sky-600 text-white shadow-sm transition hover:bg-sky-700"
        >
          <FaSearch className="h-5 w-5" />
        </button>
      </div>
    </form>
  );
}

export default SearchBox;
